/* Neon Skies Sell To Us form delivery.
   Posts the bespoke two-tab Sell form (fields + uploaded files) to a Basin
   endpoint via fetch, so the owner is emailed each submission with attachments.
   The endpoint is read from [data-sell-endpoint] (set from the section setting),
   so no code change is needed when it is pasted/updated in the theme editor. */
(function () {
  'use strict';

  var FORMS = {
    cf: {
      pane: 'sp-cards', body: 'cf-body', success: 'sm-cf',
      category: 'Pokémon Cards', terms: 'cf-terms',
      fields: { list: 'cf-list', link: 'cf-link', notes: 'cf-notes',
                first_name: 'cf-fname', last_name: 'cf-lname', email: 'cf-email',
                phone: 'cf-phone', state: 'cf-state', payment: 'cf-payment' },
      content: {
        fields: ['cf-list', 'cf-link'], files: true,
        msg: 'Please add your card list before you submit: paste it, share a link, or upload a file.'
      }
    },
    vf: {
      pane: 'sp-vg', body: 'vf-body', success: 'sm-vf',
      category: 'Video Games & Consoles', terms: 'vf-terms',
      fields: { notes: 'vf-notes', first_name: 'vf-fname', last_name: 'vf-lname',
                email: 'vf-email', phone: 'vf-phone', state: 'vf-state', payment: 'vf-payment' },
      content: {
        fields: ['vf-notes'], files: true,
        msg: 'Please add a photo of your items or some item details before submitting.'
      }
    }
  };

  var CONTACT = 'info@neonskies.com.au';

  function $(id) { return document.getElementById(id); }
  function val(id) { var el = $(id); return el ? (el.value || '').trim() : ''; }

  function endpoint() {
    var host = document.querySelector('[data-sell-endpoint]');
    return host ? (host.getAttribute('data-sell-endpoint') || '').trim() : '';
  }

  /* Collect every File chosen in the active tab's file inputs. */
  function paneFiles(prefix) {
    var pane = $(FORMS[prefix].pane);
    var inputs = pane ? pane.querySelectorAll('input[type="file"]') : [];
    var out = [];
    Array.prototype.forEach.call(inputs, function (inp) {
      if (inp.files) {
        Array.prototype.forEach.call(inp.files, function (f) { out.push(f); });
      }
    });
    return out;
  }

  /* True once the seller has actually told us what they are selling:
     at least one content field filled, or at least one file attached. */
  function hasContent(prefix, files) {
    var c = FORMS[prefix].content;
    if (!c) return true;
    var got = c.fields.some(function (id) { return val(id) !== ''; });
    if (!got && c.files) { got = files.length > 0; }
    return got;
  }

  function ensureExtras(prefix) {
    var body = $(FORMS[prefix].body);
    if (!body) return;
    if (!body.querySelector('input[name="_gotcha"]')) {
      var hp = document.createElement('input');
      hp.type = 'text'; hp.name = '_gotcha';
      hp.tabIndex = -1; hp.setAttribute('autocomplete', 'off'); hp.setAttribute('aria-hidden', 'true');
      hp.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;';
      body.appendChild(hp);
    }
    if (!$('err-' + prefix)) {
      var err = document.createElement('div');
      err.id = 'err-' + prefix;
      err.setAttribute('role', 'alert');
      err.style.cssText = 'display:none;color:#c0143c;font-size:14px;line-height:1.4;margin-top:12px;font-weight:600;';
      body.appendChild(err);
    }
  }

  function showError(prefix, msg) {
    var err = $('err-' + prefix);
    if (err) { err.textContent = msg; err.style.display = 'block'; }
  }
  function clearError(prefix) {
    var err = $('err-' + prefix);
    if (err) { err.style.display = 'none'; err.textContent = ''; }
  }

  window.submitSellForm = function (prefix) {
    var cfg = FORMS[prefix];
    if (!cfg) return;
    clearError(prefix);

    var url = endpoint();
    if (!url) { showError(prefix, 'This form is not connected yet. Please email ' + CONTACT + ' or call us and we will sort it out.'); return; }

    var files = paneFiles(prefix);
    if (!hasContent(prefix, files)) { showError(prefix, cfg.content.msg); return; }

    var email = val(cfg.fields.email);
    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      showError(prefix, 'Please enter a valid email so we can send your offer.'); return;
    }
    var terms = $(cfg.terms);
    if (terms && !terms.checked) { showError(prefix, 'Please agree to the selling terms to continue.'); return; }

    var fd = new FormData();
    fd.append('category', cfg.category);
    Object.keys(cfg.fields).forEach(function (k) {
      var v = val(cfg.fields[k]);
      if (v) fd.append(k, v);
    });
    var body = $(cfg.body);
    var hp = body.querySelector('input[name="_gotcha"]');
    fd.append('_gotcha', hp ? (hp.value || '') : '');

    files.forEach(function (file) { fd.append('attachments[]', file, file.name); });

    var btn = body.querySelector('button.btn-p');
    var original = btn ? btn.textContent.trim() : '';
    if (btn) { btn.disabled = true; btn.dataset.label = original; btn.textContent = 'Sending\u2026'; }

    fetch(url, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (res.ok) {
          body.style.display = 'none';
          var ok = $(cfg.success);
          if (ok) ok.style.display = 'block';
        } else {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          showError(prefix, 'Something went wrong sending your submission. Please try again, or email ' + CONTACT + '.');
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        showError(prefix, 'Network error. Please check your connection and try again, or email ' + CONTACT + '.');
      });
  };

  function init() {
    if (!document.querySelector('.sell-page-sec')) return;
    ensureExtras('cf');
    ensureExtras('vf');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
